<!--
Voting school selection screen
@author ab557z
-->
<template>
  <div id="contain" class="container">
  <Nav name="School Selection" />
  <div style="margin-top:16px;" class="vContainer">
      <p class="votingInstructions">Schools listed are not necessarily contested at every election.
      Once made, your selection cannot be changed until the next election year.</p>
      <ul class="list-group">
        <li v-for="value in values" :key="value.ouCode" @click="saveChoice(value.ouCode)" style="margin-bottom:10px;" class="list-group-item electionLink">
          <font-awesome-icon style="margin-top:6px;" icon="arrow-right" size="sm" class="menuChev"></font-awesome-icon>
          <b>{{value.name}}</b>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'VotingSchool',
  data () {
    return {
      values: {}
    }
  },

  mounted () {
    // Fetch the sms setting from the the server. There are only 2 editable setting right now. DOESNT WORK
    axios.get('/vote/rest/school', { withCredentials: true })
      .then(response => {
        this.values = {}
        this.values = response.data
      })
  },
  methods: {
    // Saves setting change back to server
    saveChoice (school) {
      axios.post('/vote/rest/school/save?schoolId=' + school)
        .then(response => {
          console.log(response.data)
          if (response.data == 'OK') {
            this.$router.push('/voting/login/true')
          } else {
            this.alert(response.data,
              () => {
                this.$router.push('/')
              })
          }
        })
    }
  }
}
</script>
<style>
.settingBtn {
  margin-top:-2px;
  float:right;
}
.settingHdr {
  margin-top:10px;
  margin-left:7px;
  margin-bottom:0px;
  font-weight:bold;
  color:  #074C4C; /* #686868 */
}

.settingLi {
height: 52px;
}

</style>
